import { UntypedFormControl } from '@angular/forms';
import { FormFieldType } from '@vendasta/meetings';

export enum DynamicFormControlType {
  INPUT = 'INPUT',
  EMAIL = 'EMAIL',
  PHONE = 'PHONE',
  SELECT = 'SELECT',
  CHECKBOX_GROUP = 'CHECKBOX_GROUP',
}

export interface DynamicFormField {
  id: string;
  label: string;
  required: boolean;
  formControl: UntypedFormControl;
  type: DynamicFormControlType;
  /** Original meeting-type field type, preserved so submitted answers keep the
   *  real type (e.g. DROPDOWN) rather than collapsing to SELECT. */
  originalType?: FormFieldType;
  config?: DynamicFormFieldConfig;
}

export interface DynamicFormFieldConfig {
  id?: string;
  label?: string;
  required?: boolean;
  formControl?: UntypedFormControl;
  options?: { text: string; value: string }[];
}
